import React from 'react'
import { useTranslation } from 'react-i18next'
import SectionComponent from '../../../../components/utils/SectionComponent'
import "./ticketsList.scss"

function TicketsList() {
  const {t} = useTranslation()

  return (
    <div className='container-product-performance-list'>
      <div className="texts-product-performance-list">
        
        <SectionComponent title={t("tickets.online_support.title")} text={t("tickets.online_support.section_text")}>
        </SectionComponent>


        <SectionComponent title={t("tickets.support_tickets.title")} text={t("tickets.support_tickets.section_text")}>
        </SectionComponent>

      </div>
    </div>
  )
}

export default TicketsList